// import React, { useEffect, useState } from "react";
// import {
//   GlobeAltIcon,
//   FolderOpenIcon,
//   ChartBarIcon,
// } from "@heroicons/react/24/outline";
// import {
//   BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
//   XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
// } from "recharts";
// import api from "../utils/api";
// import { useOutletContext } from 'react-router-dom';

// export default function Dashboard() {
//   const { mode } = useOutletContext(); // ← gets mode from MainLayout
//   const isDark = mode === "dark";

//   const [leadsCount, setLeadsCount] = useState(0);
//   const [projectsCount, setProjectsCount] = useState(0);
//   const [tasks, setTasks] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const user = JSON.parse(localStorage.getItem("user") || "{}");
//   const isManager = ["SuperAdmin", "Admin", "TeamLead"].includes(user.role || "");

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
//         const { data } = await api.get(endpoint);
//         setTasks(data.tasks || []);

//         const leadsRes = await api.get("/leads").catch(() => ({ data: { leads: [] } }));
//         const projectsRes = await api.get("/projects").catch(() => ({ data: { projects: [] } }));
//         setLeadsCount(leadsRes.data.leads?.length || 0);
//         setProjectsCount(projectsRes.data.projects?.length || 0);
//       } catch (err) {
//         console.error("Failed to load dashboard data", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadData();
//   }, [isManager]);

// // // src/pages/Dashboard.jsx
// // import React, { useEffect, useState } from "react";
// // import {
// //   GlobeAltIcon,
// //   FolderOpenIcon,
// //   ChartBarIcon,
// // } from "@heroicons/react/24/outline";
// // import {
// //   BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
// //   XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
// // } from "recharts";
// // import api from "../utils/api";


// // // import { useOutletContext } from 'react-router-dom';


 
// // export default function Dashboard() {
// //   const { mode } = useOutletContext();
// //   const [leadsCount, setLeadsCount] = useState(0);
// //   const [projectsCount, setProjectsCount] = useState(0);
// //   const [tasks, setTasks] = useState([]);
// //   const [loading, setLoading] = useState(true);
// // //  const { mode } = useOutletContext();

// //   const user = JSON.parse(localStorage.getItem("user") || "{}");
// //   const isManager = ["SuperAdmin", "Admin", "TeamLead"].includes(user.role || "");

// //   useEffect(() => {
// //     const loadData = async () => {
// //       try {
// //         setLoading(true);
// //         const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
// //         const { data } = await api.get(endpoint);
// //         const taskList = data.tasks || [];
// //         setTasks(taskList);

// //         const leadsRes = await api.get("/leads").catch(() => ({ data: { leads: [] } }));
// //         const projectsRes = await api.get("/projects").catch(() => ({ data: { projects: [] } }));
// //         setLeadsCount(leadsRes.data.leads?.length || leadsRes.data.length || 2);
// //         setProjectsCount(projectsRes.data.projects?.length || projectsRes.data.length || 3);
// //       } catch (err) {
// //         console.error("Failed to load dashboard data", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     loadData();
// //   }, [isManager]);

//   const employeeTasksData = React.useMemo(() => {
//     const map = {};
//     tasks.forEach(t => {
//       const name = t.assignee_name || "Unassigned";
//       if (!map[name]) map[name] = { name, total: 0, completed: 0 };
//       map[name].total++;
//       if (["Completed", "Approved"].includes(t.status)) map[name].completed++;
//     });
//     return Object.values(map).slice(0, 5);
//   }, [tasks]);

//   const tasksCompletedData = React.useMemo(() => {
//     const months = [];
//     const now = new Date();
//     for (let i = 5; i >= 0; i--) {
//       const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
//       months.push({
//         month: date.toLocaleString("default", { month: "short" }),
//         tasks: 0
//       });
//     }
//     tasks.forEach(t => {
//       if (t.completed_at || t.approved_at) {
//         const date = new Date(t.completed_at || t.approved_at);
//         const month = date.toLocaleString("default", { month: "short" });
//         const entry = months.find(m => m.month === month);
//         if (entry) entry.tasks++;
//       }
//     });
//     return months;
//   }, [tasks]);

//   const projectTypesData = React.useMemo(() => {
//     const map = {};
//     tasks.forEach(t => {
//       const dept = t.department || "Other";
//       map[dept] = (map[dept] || 0) + 1;
//     });
//     const colors = {
//       Sales: "#8b5cf6",
//       Design: "#3b82f6",
//       Production: "#22c55e",
//       Accounts: "#f59e0b",
//       Management: "#ef4444",
//       Other: "#64748b",
//     };
//     return Object.entries(map).map(([name, value]) => ({
//       name,
//       value,
//       color: colors[name] || "#64748b"
//     }));
//   }, [tasks]);

  
//   // if (loading) {
//   //   return (
//   //     <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//   //       <p className="text-gray-700 text-xl">Loading Dashboard...</p>
//   //     </div>
//   //   );
//   // }

//   // return (
//   //   <div className="min-h-screen bg-gray-50 text-gray-900 py-6 px-4 md:px-8">
//   //     {/* Compact Grid */}
//   //     <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
//   //       {/* Employee Tasks - Light Card */}
//   //       <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200">
//   //         <h3 className="text-lg font-semibold mb-4">Employee Tasks</h3>
//   //         <ResponsiveContainer width="100%" height={200}>
//   //           <BarChart data={employeeTasksData}>
//   //             <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//   //             <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
//   //             <YAxis stroke="#6b7280" fontSize={12} />
//   //             <Tooltip contentStyle={{ backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: "6px" }} />
//   //             <Bar dataKey="total" fill="#60a5fa" radius={[8, 8, 0, 0]} />
//   //             <Bar dataKey="completed" fill="#93c5fd" radius={[8, 8, 0, 0]} />
//   //           </BarChart>
//   //         </ResponsiveContainer>
//   //         <div className="flex justify-center gap-5 mt-4 text-xs">
//   //           <div className="flex items-center gap-2">
//   //             <div className="w-3 h-3 bg-blue-400 rounded" />
//   //             <span>Total</span>
//   //           </div>
//   //           <div className="flex items-center gap-2">
//   //             <div className="w-3 h-3 bg-blue-300 rounded" />
//   //             <span>Completed</span>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       {/* Tasks Completed - Light Card */}
//   //       <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200">
//   //         <h3 className="text-lg font-semibold mb-1">Tasks Completed</h3>
//   //         <p className="text-xs text-gray-500 mb-4">Last 6 months</p>
//   //         <ResponsiveContainer width="100%" height={200}>
//   //           <LineChart data={tasksCompletedData}>
//   //             <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//   //             <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
//   //             <YAxis stroke="#6b7280" fontSize={12} />
//   //             <Tooltip contentStyle={{ backgroundColor: "#fff", border: "1px solid #e5e7eb" }} />
//   //             <Line type="monotone" dataKey="tasks" stroke="#ec4899" strokeWidth={3} dot={{ fill: "#ec4899", r: 5 }} />
//   //           </LineChart>
//   //         </ResponsiveContainer>
//   //       </div>

//   //       {/* Projects KPI */}
//   //       <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200 flex flex-col justify-between">
//   //         <div>
//   //           <FolderOpenIcon className="w-10 h-10 text-gray-400 mb-3" />
//   //           <p className="text-5xl font-bold">{String(projectsCount).padStart(2, "0")}</p>
//   //           <p className="text-green-600 text-sm font-medium mt-2">+100% vs last month</p>
//   //         </div>
//   //         <h3 className="text-xl font-semibold mt-6">PROJECTS</h3>
//   //       </div>

//   //       {/* Leads KPI */}
//   //       <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200 flex flex-col justify-between">
//   //         <div>
//   //           <GlobeAltIcon className="w-10 h-10 text-gray-400 mb-3" />
//   //           <p className="text-5xl font-bold">{String(leadsCount).padStart(2, "0")}</p>
//   //           <p className="text-green-600 text-sm font-medium mt-2">+100% vs last month</p>
//   //         </div>
//   //         <h3 className="text-xl font-semibold mt-6">LEADS</h3>
//   //       </div>
//   if (loading) {
//     return (
//       <div className={`min-h-[80vh] flex items-center justify-center ${isDark ? "bg-slate-900 text-slate-300" : "bg-gray-50 text-gray-700"}`}>
//         <p className="text-xl">Loading Dashboard...</p>
//       </div>
//     );
//   }

//   const cardClass = `rounded-2xl shadow-lg p-5 border ${isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"}`;
//   const textSecondary = isDark ? "text-slate-400" : "text-gray-500";

//   return (
//     <div className={`min-h-screen py-6 px-4 md:px-8 ${isDark ? "bg-slate-900 text-slate-100" : "bg-gray-50 text-gray-900"}`}>
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
//         {/* Employee Tasks */}
//         <div className={cardClass}>
//           <h3 className="text-lg font-semibold mb-4">Employee Tasks</h3>
//           <ResponsiveContainer width="100%" height={200}>
//             <BarChart data={employeeTasksData}>
//               <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#475569" : "#e5e7eb"} />
//               <XAxis dataKey="name" stroke={isDark ? "#94a3b8" : "#6b7280"} fontSize={12} />
//               <YAxis stroke={isDark ? "#94a3b8" : "#6b7280"} fontSize={12} />
//               <Tooltip contentStyle={{ backgroundColor: isDark ? "#1e293b" : "#fff", border: `1px solid ${isDark ? "#475569" : "#e5e7eb"}`, borderRadius: "6px" }} />
//               <Bar dataKey="total" fill="#60a5fa" radius={[8, 8, 0, 0]} />
//               <Bar dataKey="completed" fill="#93c5fd" radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//           <div className={`flex justify-center gap-5 mt-4 text-xs ${textSecondary}`}>
//             <div className="flex items-center gap-2">
//               <div className="w-3 h-3 bg-blue-400 rounded" />
//               <span>Total</span>
//             </div>
//             <div className="flex items-center gap-2">
//               <div className="w-3 h-3 bg-blue-300 rounded" />
//               <span>Completed</span>
//             </div>
//           </div>
//         </div>

//         {/* Tasks Completed */}
//         <div className={cardClass}>
//           <h3 className="text-lg font-semibold mb-1">Tasks Completed</h3>
//           <p className={`text-xs mb-4 ${textSecondary}`}>Last 6 months</p>
//           <ResponsiveContainer width="100%" height={200}>
//             <LineChart data={tasksCompletedData}>
//               <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#475569" : "#e5e7eb"} />
//               <XAxis dataKey="month" stroke={isDark ? "#94a3b8" : "#6b7280"} fontSize={12} />
//               <YAxis stroke={isDark ? "#94a3b8" : "#6b7280"} fontSize={12} />
//               <Tooltip contentStyle={{ backgroundColor: isDark ? "#1e293b" : "#fff", border: `1px solid ${isDark ? "#475569" : "#e5e7eb"}`, borderRadius: "6px" }} />
//               <Line type="monotone" dataKey="tasks" stroke="#ec4899" strokeWidth={3} dot={{ fill: "#ec4899", r: 5 }} />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>

//         {/* KPI Cards (Projects & Leads) */}
//         <div className={`${cardClass} flex flex-col justify-between`}>
//           <div>
//             <FolderOpenIcon className={`w-10 h-10 mb-3 ${isDark ? "text-slate-500" : "text-gray-400"}`} />
//             <p className="text-5xl font-bold">{String(projectsCount).padStart(2, "0")}</p>
//             <p className={`text-sm font-medium mt-2 ${isDark ? "text-emerald-400" : "text-green-600"}`}>
//               +100% vs last month
//             </p>
//           </div>
//           <h3 className="text-xl font-semibold mt-6">PROJECTS</h3>
//         </div>

//         {/* Task Analytics Placeholder */}
//         <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200 flex flex-col items-center justify-center text-center">
//           <ChartBarIcon className="w-12 h-12 text-gray-400 mb-3" />
//           <h3 className="text-lg font-semibold">Task Analytics</h3>
//           <p className="text-xs text-gray-500 mt-2 max-w-xs">
//             Task completion patterns across projects
//           </p>
//         </div>

//         {/* Project Types - Pie Chart */}
//         <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200">
//           <h3 className="text-lg font-semibold mb-1">PROJECT TYPES</h3>
//           <p className="text-xs text-gray-500 mb-4">By department</p>
//           <ResponsiveContainer width="100%" height={240}>
//             <PieChart>
//               <Pie
//                 data={projectTypesData}
//                 cx="50%"
//                 cy="50%"
//                 innerRadius={60}
//                 outerRadius={90}
//                 paddingAngle={4}
//                 dataKey="value"
//               >
//                 {projectTypesData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={entry.color} />
//                 ))}
//               </Pie>
//               <Tooltip />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// }


// src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {
  FolderOpenIcon,
  GlobeAltIcon,ChartBarIcon,
} from "@heroicons/react/24/outline";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import api from "../utils/api";

const COLORS = ["#8b5cf6", "#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#64748b"];

export default function Dashboard() {
  const { mode } = useOutletContext();
  const isDark = mode === "dark";

  const [leadsCount, setLeadsCount] = useState(0);
  const [projectsCount, setProjectsCount] = useState(0);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isManager = ["SuperAdmin", "Admin", "TeamLead"].includes(user.role || "");

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const endpoint = isManager ? "/tasks?team=true" : "/tasks?mine=true";
        const { data } = await api.get(endpoint);
        setTasks(data.tasks || []);

        const leadsRes = await api.get("/leads").catch(() => ({ data: { leads: [] } }));
        const projectsRes = await api.get("/projects").catch(() => ({ data: { projects: [] } }));
        setLeadsCount(leadsRes.data.leads?.length || 0);
        setProjectsCount(projectsRes.data.projects?.length || 0);
      } catch (err) {
        console.error("Failed to load dashboard data", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [isManager]);

  const employeeTasksData = React.useMemo(() => {
    const map = {};
    tasks.forEach((t) => {
      const name = t.assignee_name || "Unassigned";
      if (!map[name]) map[name] = { name, total: 0, completed: 0 };
      map[name].total++;
      if (["Completed", "Approved"].includes(t.status)) map[name].completed++;
    });
    return Object.values(map).slice(0, 5);
  }, [tasks]);

  const tasksCompletedData = React.useMemo(() => {
    const months = [];
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push({
        month: date.toLocaleString("default", { month: "short" }),
        tasks: 0,
      });
    }
    tasks.forEach((t) => {
      if (t.completed_at || t.approved_at) {
        const date = new Date(t.completed_at || t.approved_at);
        const month = date.toLocaleString("default", { month: "short" });
        const entry = months.find((m) => m.month === month);
        if (entry) entry.tasks++;
      }
    });
    return months;
  }, [tasks]);

  const projectTypesData = React.useMemo(() => {
    const map = {};
    tasks.forEach((t) => {
      const dept = t.department || "Other";
      map[dept] = (map[dept] || 0) + 1;
    });
    return Object.entries(map).map(([name, value]) => ({
      name,
      value,
      color: COLORS[Object.keys(map).indexOf(name) % COLORS.length],
    }));
  }, [tasks]);

  if (loading) {
    return (
      <div
        className={`min-h-[80vh] flex items-center justify-center ${
          isDark ? "bg-slate-900 text-slate-300" : "bg-gray-50 text-gray-700"
        }`}
      >
        <p className="text-xl">Loading Dashboard...</p>
      </div>
    );
  }

  return (
    <div className={`min-h-screen py-6 px-4 md:px-8 ${isDark ? "bg-slate-950" : "bg-gray-50"}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Employee Tasks - Dark card style */}
        <div
          className={`rounded-2xl shadow-xl p-5 border ${
            isDark ? "bg-gray-900 border-gray-800" : "bg-white border-gray-200"
          }`}
        >
          <h3 className={`text-lg font-semibold mb-4 ${isDark ? "text-white" : "text-gray-900"}`}>
            Employee Tasks
          </h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={employeeTasksData}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke={isDark ? "#374151" : "#e5e7eb"}
                vertical={false}
              />
              <XAxis dataKey="name" stroke={isDark ? "#9ca3af" : "#6b7280"} fontSize={12} />
              <YAxis stroke={isDark ? "#9ca3af" : "#6b7280"} fontSize={12} />
              <Tooltip
                contentStyle={{
                  backgroundColor: isDark ? "#1f2937" : "#ffffff",
                  border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
                  color: isDark ? "#f3f4f6" : "#111827",
                  borderRadius: "8px",
                }}
              />
              <Bar dataKey="total" fill="#60a5fa" radius={[8, 8, 0, 0]} />
              <Bar dataKey="completed" fill="#34d399" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
          <div className={`flex justify-center gap-6 mt-4 text-xs ${isDark ? "text-gray-400" : "text-gray-500"}`}>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-blue-400 rounded-full" />
              <span>Total</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-emerald-400 rounded-full" />
              <span>Completed</span>
            </div>
          </div>
        </div>

        {/* Tasks Completed Line Chart */}
        <div
          className={`rounded-2xl shadow-xl p-5 border ${
            isDark ? "bg-gray-900 border-gray-800" : "bg-white border-gray-200"
          }`}
        >
          <h3 className={`text-lg font-semibold mb-1 ${isDark ? "text-white" : "text-gray-900"}`}>
            Tasks Completed
          </h3>
          <p className={`text-xs mb-4 ${isDark ? "text-gray-400" : "text-gray-500"}`}>
            April - September 2025
          </p>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={tasksCompletedData}>
              <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#374151" : "#e5e7eb"} />
              <XAxis dataKey="month" stroke={isDark ? "#9ca3af" : "#6b7280"} fontSize={12} />
              <YAxis stroke={isDark ? "#9ca3af" : "#6b7280"} fontSize={12} />
              <Tooltip
                contentStyle={{
                  backgroundColor: isDark ? "#1f2937" : "#ffffff",
                  border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
                  color: isDark ? "#f3f4f6" : "#111827",
                  borderRadius: "8px",
                }}
              />
              <Line
                type="monotone"
                dataKey="tasks"
                stroke="#ec4899"
                strokeWidth={3}
                dot={{ fill: "#ec4899", r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Projects KPI - Black Card */}
        <div
          className={`rounded-2xl shadow-xl p-6 border flex flex-col justify-between ${
            isDark ? "bg-black border-gray-800" : "bg-gray-900 border-gray-700"
          }`}
        >
          <div className="flex items-start justify-between">
            <div>
              <FolderOpenIcon className={`w-10 h-10 mb-4 ${isDark ? "text-gray-400" : "text-gray-300"}`} />
              <p className="text-5xl font-bold text-white">{String(projectsCount).padStart(5, "0")}</p>
              <p className={`text-sm font-medium mt-2 ${isDark ? "text-emerald-400" : "text-emerald-400"}`}>
                PROJECTS
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-emerald-400">+100% compared to previous month</p>
            </div>
          </div>
        </div>

        {/* Leads KPI - Black Card */}
        <div
          className={`rounded-2xl shadow-xl p-6 border flex flex-col justify-between ${
            isDark ? "bg-black border-gray-800" : "bg-gray-900 border-gray-700"
          }`}
        >
          <div className="flex items-start justify-between">
            <div>
              <GlobeAltIcon className={`w-10 h-10 mb-4 ${isDark ? "text-gray-400" : "text-gray-300"}`} />
              <p className="text-5xl font-bold text-white">{String(leadsCount).padStart(5, "0")}</p>
              <p className={`text-sm font-medium mt-2 ${isDark ? "text-emerald-400" : "text-emerald-400"}`}>
                LEADS
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-emerald-400">+100% compared to previous month</p>
            </div>
          </div>
        </div>

        {/* Task Analytics Placeholder */}
        <div
          className={`rounded-2xl shadow-xl p-6 border flex flex-col items-center justify-center text-center ${
            isDark ? "bg-gray-900 border-gray-800" : "bg-white border-gray-200"
          }`}
        >
          <ChartBarIcon className={`w-12 h-12 mb-3 ${isDark ? "text-gray-400" : "text-gray-500"}`} />
          <h3 className={`text-lg font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>
            Task Analytics
          </h3>
          <p className={`text-xs mt-2 max-w-xs ${isDark ? "text-gray-400" : "text-gray-500"}`}>
            Task completion patterns over time across all projects
          </p>
        </div>

        {/* Project Types - Pie Chart */}
        <div
          className={`rounded-2xl shadow-xl p-6 border ${
            isDark ? "bg-gray-900 border-gray-800" : "bg-white border-gray-200"
          }`}
        >
          <h3 className={`text-lg font-semibold mb-1 ${isDark ? "text-white" : "text-gray-900"}`}>
            PROJECT TYPES
          </h3>
          <p className={`text-xs mb-4 ${isDark ? "text-gray-400" : "text-gray-500"}`}>Distribution by category</p>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={projectTypesData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={4}
                dataKey="value"
              >
                {projectTypesData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: isDark ? "#1f2937" : "#ffffff",
                  border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
                  color: isDark ? "#f3f4f6" : "#111827",
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}